import { dcpcApi } from './dcpcApi';

export const ENTITY_PARAMS_TAG = 'entityParams';

dcpcApi.enhanceEndpoints({ addTagTypes: [ENTITY_PARAMS_TAG] });
const vocEntityParamsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getEntityParamsByEntityTypeCode: builder.query({
      query: (code) => `/voc-entity-params/${code}/all`,
      providesTags: [ENTITY_PARAMS_TAG],
    }),

    getEntityParamById: builder.query({
      query: (code) => `/voc-entity-params/${code}`,
      providesTags: [ENTITY_PARAMS_TAG],
    }),

    updateEntityParamById: builder.mutation({
      query: ({ code, body }) => ({
        url: `/voc-entity-params${code ? `/${code}` : ''}`,
        method: code ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [ENTITY_PARAMS_TAG],
    }),

    deleteEntityParamById: builder.mutation({
      query: (code) => ({
        url: `/voc-entity-params/${code}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ENTITY_PARAMS_TAG],
    }),
  }),
});

export const {
  useGetEntityParamsByEntityTypeCodeQuery,
  useGetEntityParamByIdQuery,
  useUpdateEntityParamByIdMutation,
  useDeleteEntityParamByIdMutation,
} = vocEntityParamsApi;
